import React, { useCallback, useEffect, useState } from 'react';
import { BiCalendar, BiDownload } from 'react-icons/bi';
import { Link, useLocation } from 'react-router-dom';
import { format } from 'date-fns';

import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import api from '../../services/api';

import getFormatedDate from '../../utils/getFormatedDate';
import getParamsUri from '../../utils/getParamsUri';

interface Result {
  id: number;
  date: Date;
  path1: string;
  path2: string;
  path3: string;
  path3_nome: string;
  path2_nome: string;
  path1_nome: string;
  edition_name: string;
  company: string;
  page: string;
  position: 'left' | 'right';
  type: string;
}

interface SearchParams {
  company?: string;
  cnpj?: string;
  datei?: Date;
  datef?: Date;
  date?: string;
  edition_id?: string;
  type?: string;
}

const Search: React.FC = () => {
  const location = useLocation();

  const [results, setResults] = useState<Result[]>();
  const [downloadRow, setDownloadRow] = useState<number>();

  const handleListResults = useCallback(async () => {
    let params = getParamsUri<SearchParams>(location.search);
    if (!params) {
      params = { date: format(new Date(), 'yyyy-MM-dd') };
    }

    await api
      .get<Result[]>('search', {
        params,
      })
      .then(response => {
        setResults(response.data);
      });
  }, [location.search]);

  useEffect(() => {
    handleListResults();
  }, [handleListResults]);

  const handleDownloadRow = useCallback(
    (resultRow: number) => {
      let resultRowActive = resultRow;
      if (resultRow === downloadRow) {
        resultRowActive = 0;
      }
      setDownloadRow(resultRowActive);
    },
    [downloadRow],
  );

  return (
    <>
      <h5>RESULTADOS DA BUSCA</h5>

      <div className="p-3" />

      {results && results.length ? (
        <div className="table-responsive">
          <table className="table" width="100%">
            <colgroup>
              <col width="80" />
              <col width="" />
            </colgroup>
            <thead>
              <tr>
                <th className="icons text-center">
                  <BiCalendar size={30} />
                </th>
                <th>CADERNO</th>
                <th>TIPO</th>
                <th>EMPRESA</th>
                <th>PÁGINA</th>
                <th>{` `}</th>
              </tr>
            </thead>
            <tbody>
              {results.map(result => (
                <>
                  <tr key={result.id}>
                    <td>{getFormatedDate(result.date.toString())}</td>
                    <td>{result.edition_name}</td>
                    <td>{result.type}</td>
                    <td>{result.company}</td>
                    <td>{result.page}</td>
                    <td className="icons text-right">
                      {result.path1 && (
                        <button
                          type="button"
                          className="btn btn-sm p-0"
                          onClick={() => handleDownloadRow(result.id)}
                        >
                          {downloadRow === result.id ? (
                            <FiChevronUp size={30} />
                          ) : (
                            <FiChevronDown size={30} />
                          )}
                        </button>
                      )}
                    </td>
                  </tr>
                  <tr className={downloadRow === result.id ? 'show' : 'hide'}>
                    <td colSpan={6} className="text-right">
                      <div>
                        {result.path3 && (
                          <a
                            href={result.path3}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {result.path3_nome}
                            {` `}
                            <BiDownload size={18} />
                          </a>
                        )}
                        {result.path2 && (
                          <a
                            href={result.path2}
                            target="_blank"
                            rel="noreferrer"
                            style={{marginLeft: 15}}
                          >
                            {result.path2_nome}
                            {` `}
                            <BiDownload size={18} />
                          </a>
                        )}
                        {result.path1 && (
                          <a
                            href={result.path1}
                            target="_blank"
                            rel="noreferrer"
                            style={{marginLeft: 15}}
                          >
                            {result.path1_nome}
                            {` `}
                            <BiDownload size={18} />
                          </a>
                        )}
                      </div>
                    </td>
                  </tr>
                </>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div>
          {results && results.length === 0 ? (
            <div>Nenhum resultado encontrado.</div>
          ) : (
            <div>Pesquisando, aguarde...</div>
          )}
        </div>
      )}

      <div className="d-flex justify-content-center">
        <Link className="btn btn-primary bottom" to="/">
          REALIZAR NOVA BUSCA
        </Link>
      </div>
    </>
  );
};

export default Search;
